module.exports = __webpack_public_path__ + "img/guide-cod-2-pop.8922211f.png";